export type AssetCategory = {
  name: string;
  code: string;
};

export const assetCategories: Array<AssetCategory> = [
  { name: 'Characters', code: 'CHARACTERS' },
  { name: 'Nature', code: 'NATURE' },
  { name: 'Others', code: 'OTHERS' },
  { name: 'Plant a tree Reward', code: 'PLANT_A_TREE_REWARD' },
];

export const getAssetCategoryName = (code: string) => {
  const asset = assetCategories.find((a) => a.code === code);
  return asset && asset.name;
};

export const getAssetCategoryCode = (name: string) => {
  const asset = assetCategories.find((a) => a.name === name);
  return asset && asset.code;
};
